export default __webpack_public_path__ + "static/media/r.7db8c8bd.mp3";